import type { ServiceType } from '@/legacy-src/types/GeneralStateType'
import type { TherapistType } from '@/legacy-src/types/TherapistStateType'

import { CartContext } from '@/src/domains/cart/contexts/Cart.context'
import { TherapistCartContext } from '@/src/domains/cart/contexts/TherapistCart.context'
import { useCartAutoVoucher } from '@/src/domains/cart/hooks/useCartAutoVoucher'

import { useTherapistCartState } from './TherapistCartProvider.hooks'
import { TherapistCartProviderGuards } from './TherapistCartProviderGuards'

interface TherapistCartProviderProps {
  children: React.ReactNode
  therapist: TherapistType
  service: ServiceType
}

export const TherapistCartProvider = ({ therapist, service, children }: TherapistCartProviderProps) => {
  const { cart, therapistCart } = useTherapistCartState({
    therapistId: therapist.therapistId,
    serviceId: service.id,
    serviceType: service.type,
  })

  useCartAutoVoucher({ voucher: cart.voucher, setVoucher: cart.setVoucher })

  return (
    <CartContext.Provider value={cart}>
      <TherapistCartContext.Provider value={therapistCart}>
        <TherapistCartProviderGuards />
        {children}
      </TherapistCartContext.Provider>
    </CartContext.Provider>
  )
}
